/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_No_UnitInputs */

const en_editor_ingredient_no_unit = /** @type {(inputs: Editor_Ingredient_No_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`–`)
};

const de_editor_ingredient_no_unit = /** @type {(inputs: Editor_Ingredient_No_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`–`)
};

/**
* | output |
* | --- |
* | "–" |
*
* @param {Editor_Ingredient_No_UnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_no_unit = /** @type {((inputs?: Editor_Ingredient_No_UnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_No_UnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_no_unit(inputs)
	return en_editor_ingredient_no_unit(inputs)
});